import { render } from "./pastConferences.vue?vue&type=template&id=fb79e7b8"
import script from "./pastConferences.vue?vue&type=script&lang=js"
export * from "./pastConferences.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__